import React, { useEffect } from "react";
import { useFCM } from "../hooks/useFCM";
import { onMessage } from "firebase/messaging";
import { messaging } from "../firebase/firebase.config";
import { toast } from "react-toastify";

export const NotificationHandler = () => {
  const { fcmToken, error } = useFCM();

  useEffect(() => {
    if (error) {
      // toast.error("Failed to enable notifications: " + error);
    }
  }, [error]);

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      const { title, body, image } = payload.notification || {};

      toast.info(body, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: image ? (
          <img
            src={image}
            alt="notification"
            style={{ width: 24, height: 24 }}
          />
        ) : undefined,
      });
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return null;
};
